import { Observer, } from 'common/classes';

export const unauthorizedObserver = new Observer();
